<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query'
import { confirmSellerInternationalPaymentAction } from '@/api/functions/transactions/transaction-status.action'
import { useMutationApi } from '@/composables/useApi'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'

const props = defineProps({
  images: { type: Array as () => string[], default: () => [] },
  uuid: { type: String, required: true },
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const toast = useToast()
const queryClient = useQueryClient()

const closeModal = () => {
  emit('update:modelValue', false)
  emit('cancel')
}

const confirmMutation = useMutationApi({
  mutationFn: () => confirmSellerInternationalPaymentAction(props.uuid),
  onSuccess: () => {
    toast.success('پرداخت فروشنده با موفقیت تایید شد')
    queryClient.invalidateQueries({ queryKey: ['transaction', props.uuid] })
    emit('confirm')
    closeModal()
  },
  onError: (err: Error) => {
    toast.error(getErrorMessage(err))
  },
})

const confirmSave = () => {
  if (confirmMutation.isPending.value) return
  confirmMutation.mutate()
}

const openImageInNewTab = (url: string) => {
  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<template>
    <Modal :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)" width="600px"
        background="#FFF" :closable="true" title="تایید پرداخت فروشنده" closeDirection="left" class="update-request">
        <div class="flex flex-col h-[400px]">

            <div class="flex-1 px-4 py-6 pb-9 space-y-1">
                <div class="text-[#2d5396] text-lg font-medium">سند رسید</div>

                <div v-for="(img, index) in images" :key="`img-${index}`" class="mt-4">
                    <div class="w-full flex flex-col items-center lg:items-start">
                        <div class="w-full gap-16 lg:w-fit flex items-center">
                            <img :src="img" class="w-full lg:w-[198px] h-[248px] object-cover rounded-lg" />
                            <Button @click.stop="openImageInNewTab(img)" :isAdmin="true"
                                class="w-fit px-5! rounded-lg h-10! py-0 text-[13px]">
                                <span class="text-nowrap flex items-center justify-center gap-2">دانلود</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sticky bottom-0 bg-white z-50 flex justify-between gap-6 w-full pt-3 pb-9 px-2 border-gray-200">
                <Button @click="confirmSave" type="button" label="تایید پرداخت فروشنده" :isAdmin="true"
                    :disabled="confirmMutation.isPending.value" class="w-9/12 h-12 rounded-xl" />
                <Button type="button" @click="closeModal" variant="outline" label="بازگشت" :isAdmin="true"
                    class="w-4/12 h-12 rounded-xl border-2" />
            </div>

        </div>
    </Modal>
</template>
